export function closeDataDialogOnBackdrop(dialog: HTMLDialogElement): void {
  const outside = (event: MouseEvent) => {
    const bounds = dialog.getBoundingClientRect();
    return event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
  };
  let startedOutside = false;
  dialog.addEventListener('pointerdown', (event) => { startedOutside = outside(event); });
  dialog.addEventListener('click', (event) => {
    if (startedOutside && outside(event)) dialog.close();
    startedOutside = false;
  });
}

export function fieldSelect(parent: HTMLElement, labelText: string): HTMLSelectElement {
  const label = document.createElement('label'); label.textContent = labelText;
  const input = document.createElement('select'); input.setAttribute('aria-label', labelText);
  label.appendChild(input); parent.appendChild(label); return input;
}
export function fieldOption(select: HTMLSelectElement, value: string, label: string): void {
  const item = document.createElement('option'); item.value = value; item.textContent = label; select.appendChild(item);
}
